import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useMemo } from "react";
import { Col, Container, Row } from "reactstrap";
import { useYoutubeCore } from "../../../../cores/youtube";
import { useSocialPostCore } from "../../../../cores/socialPost";
import { SocialProviderId } from "../../../../cores/socialPost/config";
import { PostType } from "../../../../cores/socialPost/enums/postType";
import { PostError } from "../../../../cores/socialPost/interfaces/postError";
import { ErrorList } from "./ErrorList";
import { MediaPreview } from "./MediaPreview";
import "../../../styles/YoutubePostPreview.scss";

export const YoutubePostPreview = () => {
  const { settings, directPostDraft } = useYoutubeCore();
  const { text, postErrors, postType } = useSocialPostCore();
  const { name, avatarUrl } = settings || {};
  const isShort = postType === PostType.SHORT;

  const providerErrors: PostError[] = useMemo(
    () =>
      postErrors.filter(
        ({ socialProviderId }) =>
          socialProviderId === SocialProviderId.YouTube
      ),
    [postErrors]
  );

  const displayTitle = directPostDraft.title || text.slice(0, 80) || "Título del video";

  return providerErrors.length > 0 ? (
    <ErrorList errors={providerErrors} />
  ) : (
    <div
      className={`youtube-preview-container neu-out ${isShort ? "youtube-preview-container--short" : ""}`}
    >
      <Container fluid className="youtube-preview-wrapper p-0">
        <div className="youtube-preview-player">
          <MediaPreview className="youtube-preview-media" />
          <div className="youtube-preview-duration">
            {isShort ? "Short" : "Video"}
          </div>
        </div>
        <div className="youtube-preview-meta px-2 py-2">
          <h6 className="youtube-preview-title mb-1">{displayTitle}</h6>
          <div className="d-flex align-items-center mb-2">
            {avatarUrl ? (
              <img
                src={avatarUrl}
                alt=""
                className="youtube-preview-avatar mr-2"
              />
            ) : (
              <div className="youtube-preview-avatar youtube-preview-avatar--placeholder mr-2" />
            )}
            <div>
              <div className="youtube-preview-channel small font-weight-bold">
                {name ?? "Canal YouTube"}
              </div>
              <div className="text-muted" style={{ fontSize: "10px" }}>
                0 vistas · recién publicado
              </div>
            </div>
          </div>
          <Row className="youtube-preview-actions mx-0">
            <Col xs="4" className="text-center p-1">
              <FontAwesomeIcon icon={["fas", "thumbs-up"]} />
              <div style={{ fontSize: "9px" }}>Me gusta</div>
            </Col>
            <Col xs="4" className="text-center p-1">
              <FontAwesomeIcon icon={["fas", "share"]} />
              <div style={{ fontSize: "9px" }}>Compartir</div>
            </Col>
            <Col xs="4" className="text-center p-1">
              <FontAwesomeIcon icon={["fas", "download"]} />
              <div style={{ fontSize: "9px" }}>Descargar</div>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
};
